import CrudTab from 'react/containers/pages/CrudTab';

class DataImportOld extends CrudTab {

  static tabName = 'Greenmile.DataImport.screenName'

  componentDidMount() {
    this.router = new App.Routers.DataImportOld();
    this.router.show();
  }

  componentDidUpdate() {
    return true;
  }

}

export default DataImportOld;
